<template>
    <div class="settings-template-main">
        <div class="settings-template-section">
            <menu-tabs @setMenuOption="setMenuOption" @selectedProperty="selectedProperty"></menu-tabs>
            <div class="mr-6" :class="{ 'pt-1': !isPropertySelected }">
                <template v-if="level === 'property' && !property.id">
                    <hb-empty-state message="Please select a Property to continue." />
                </template>
                <template v-else>
                    <div class="d-flex justify-space-between align-center mb-4 mt-5">
                        <HbTextField search width="400px" v-model="searchTemplate" v-validate="'required|max:45'"
                            data-vv-scope="default" data-vv-name="search-templates" data-vv-as="search-templates"
                            :error="errors.has('default.search-templates')" @click:clear="clearSearch"
                            @input="onSearchInput" placeholder="Search Templates" />
                        <div>
                            <HbBtn type="icon" active-state-off tooltip="Filter" @click="ShowFilter = true"
                                class="mr-3">
                                <template>
                                    <v-badge color="#F26500" :content="isFilterApplied" :value="isFilterApplied > 0">
                                        <hb-icon>mdi-filter-variant</hb-icon>
                                    </v-badge>
                                </template>
                            </HbBtn>
                            <hb-btn color="secondary" small @click="createNewTemplate()"
                                v-if="level !== 'property'">Create
                                New Template</hb-btn>
                            <!-- <hb-btn color="secondary" small @click="assignTemplate()" v-if="level == 'property'">
                                Assign Template</hb-btn> -->
                        </div>
                    </div>
                    <v-expansion-panels ref="expansionPanels" v-resize="resizeContainer" v-model="templatesPanel"
                        multiple>
                        <hb-expansion-panel>
                            <template v-slot:title>
                                System Communications
                            </template>
                            <template v-slot:content>
                                <div v-if="mainLoading" class="d-flex justify-center pa-4">
                                    <v-progress-circular indeterminate color="primary" />
                                </div>
                                <div v-else-if="defaultTemplateList && defaultTemplateList.length != 0">
                                    <div style="margin: 7px;" v-for="item in defaultTemplateList" :key="item.id">
                                        <hb-btn
                                            :class="{ 'expansion-panel-item-small-width': isExpansionPanelWidthBelow800 }"
                                            class="expansion-panel-item" mega @click="editTemplate(item, 'system')">
                                            <hb-tooltip>
                                                <template v-slot:item>
                                                    {{ item.name }}
                                                </template>
                                                <template v-slot:body>
                                                    {{ item.name }}
                                                </template>
                                            </hb-tooltip>
                                            <template v-slot:actions>
                                                <div class="container-main">
                                                    <div class="hb-font-body-medium ml-3 child-category">{{
                                                        getCategory(item.category) |
                                                        capitalize }}

                                                    </div>
                                                    <div class="hb-font-body-medium ml-3 child-type">{{
                                                        item.type
                                                        |
                                                        capitalize }}

                                                    </div>
                                                    <div class="hb-font-body-medium mx-6 child-property">
                                                        <div class="d-flex flex-column">
                                                            <hb-tooltip>
                                                                <template v-slot:item>
                                                                    <span>
                                                                        <span
                                                                            style="border-bottom: 1px dashed #101318; padding-bottom: 2px;">
                                                                            {{ item?.applied_properties.length }} {{
                                                                                item?.applied_properties.length
                                                                                    <= 1 ? 'Property' : 'Properties' }} </span>
                                                                        </span>
                                                                </template>
                                                                <template v-slot:body>
                                                                    <!-- Show Modified Properties First -->
                                                                    <template v-if="level !== 'property'">
                                                                        <span class="hb-font-body-medium"
                                                                            v-if="item?.modified_properties?.length">
                                                                            Property Modified ({{
                                                                                item?.modified_properties?.length }})
                                                                        </span>
                                                                        <div class="d-flex"
                                                                            v-if="item?.modified_properties?.length">
                                                                            <div class="mr-1">
                                                                                <HbIcon
                                                                                    :mdi-code="TEMPLATE.ICONS.property_modified.icon"
                                                                                    small
                                                                                    :color="TEMPLATE.ICONS.property_modified.icon_color" />
                                                                            </div>
                                                                            <div v-html="TEMPLATE.ICONS.property_modified.name"
                                                                                class="font-weight-medium"></div>
                                                                        </div>
                                                                        <template
                                                                            v-if="item?.modified_properties?.length">
                                                                            <div v-for="p in item?.modified_properties"
                                                                                :key="p.id">
                                                                                <span v-if="p">{{ p?.property_number }}
                                                                                    - {{
                                                                                        p?.property_name }}</span>
                                                                            </div>
                                                                        </template>
                                                                        <v-spacer class="mt-2"></v-spacer>
                                                                    </template>

                                                                    <!-- Show Applied Properties Only If They Are Not in Modified Properties -->

                                                                    <template v-if="item?.applied_properties?.length">
                                                                        <span class="hb-font-body-medium">
                                                                            Applies to {{
                                                                                item?.applied_properties.length }}
                                                                            {{ item?.applied_properties.length <= 1
                                                                                ? 'Property' : 'Properties' }} </span>
                                                                                <div class="d-flex">
                                                                                    <div class="mr-1">
                                                                                        <HbIcon
                                                                                            :mdi-code="TEMPLATE.ICONS[item.templateStatus].icon"
                                                                                            small
                                                                                            :color="TEMPLATE.ICONS[item.templateStatus].icon_color" />
                                                                                    </div>
                                                                                    <div v-html="TEMPLATE.ICONS[item.templateStatus].name"
                                                                                        class="font-weight-medium">
                                                                                    </div>
                                                                                </div>
                                                                                <div v-for="p in item?.applied_properties"
                                                                                    :key="p.id">
                                                                                    <span v-if="p">{{ p?.property_number
                                                                                        }} - {{ p?.property_name
                                                                                        }}</span>
                                                                                </div>
                                                                    </template>
                                                                </template>
                                                            </hb-tooltip>
                                                        </div>
                                                    </div>
                                                    <div class="mx-2 d-flex align-center pr-1 child-status ">
                                                        <div class="mr-1">
                                                            <HbIcon :mdi-code="TEMPLATE.ICONS[item.templateStatus].icon"
                                                                small
                                                                :color="TEMPLATE.ICONS[item.templateStatus].icon_color" />
                                                        </div>
                                                        <div v-html="TEMPLATE.ICONS[item.templateStatus].name"
                                                            class="font-weight-medium"></div>
                                                    </div>
                                                    <div class="child">
                                                        <hb-tooltip>
                                                            <template v-slot:item>
                                                                <HbIcon mdi-code="mdi-account-clock-outline"
                                                                    class="mx-2" small />
                                                            </template>
                                                            <template v-slot:header>
                                                                Last Modified
                                                            </template>
                                                            <template v-slot:body>
                                                                <div v-if="item.modified_by?.name">
                                                                    {{
                                                                        item.modified_by.name
                                                                    }}</div>
                                                                <div v-if="item.updated_at">
                                                                    {{
                                                                        formatUpdatedAt(item.updated_at)
                                                                    }}</div>
                                                            </template>
                                                        </hb-tooltip>
                                                    </div>
                                                    <div class="child"><hb-menu options>
                                                            <v-list>
                                                                <v-list-item @click="editTemplate(item, 'system')">
                                                                    <v-list-item-title>Edit</v-list-item-title>
                                                                </v-list-item>
                                                                <v-list-item @click="resetToDefOrCorp(item, level)"
                                                                    v-if="item.templateStatus != 'tenant_template'"
                                                                    :disabled="item.templateStatus == 'corporate_modified' && level == 'property'">
                                                                    <v-list-item-title v-if="level == 'property'">Reset
                                                                        to Corporate</v-list-item-title>
                                                                    <v-list-item-title v-else>Reset to
                                                                        Default</v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                        </hb-menu>
                                                    </div>
                                                </div>
                                            </template>
                                        </hb-btn>
                                    </div>
                                </div>
                                <div v-else-if="defaultTemplateList.length == 0 && !mainLoading" class="pa-4">
                                    <hb-empty-state
                                        :message="isFilterApplied ? 'No templates found' : 'You have no templates yet.'" />
                                </div>
                            </template>
                        </hb-expansion-panel>
                        <hb-expansion-panel :top-margin="true">
                            <template v-slot:title>
                                User Defined Communications
                            </template>
                            <template v-slot:content>
                                <div v-if="mainLoading" class="d-flex justify-center pa-4">
                                    <v-progress-circular indeterminate color="primary" />
                                </div>
                                <div v-else-if="userGeneratedTemplates && userGeneratedTemplates.length != 0">
                                    <div style="margin: 7px;" v-for="item in userGeneratedTemplates" :key="item.id">
                                        <hb-btn
                                            :class="{ 'expansion-panel-item-small-width': isExpansionPanelWidthBelow800 }"
                                            class="expansion-panel-item" mega
                                            @click="editTemplate(item, 'user-generated')">
                                            <hb-tooltip>
                                                <template v-slot:item>
                                                    {{ item.name }}
                                                </template>
                                                <template v-slot:body>
                                                    {{ item.name }}
                                                </template>
                                            </hb-tooltip>
                                            <template v-slot:actions>
                                                <div class="container-main">
                                                    <div class="hb-font-body-medium ml-3 child-category">{{
                                                        getCategory(item.category) |
                                                        capitalize }}

                                                    </div>
                                                    <div class="hb-font-body-medium child-type">{{
                                                        item.type
                                                        |
                                                        capitalize }}

                                                    </div>
                                                    <div class="hb-font-body-medium mx-6 child-property">
                                                        <div class="d-flex flex-column">
                                                            <hb-tooltip>
                                                                <template v-slot:item>
                                                                    <span>
                                                                        <span
                                                                            style="border-bottom: 1px dashed #101318; padding-bottom: 2px;">
                                                                            {{ item?.applied_properties.length }} {{
                                                                                item?.applied_properties.length
                                                                                    <= 1 ? 'Property' : 'Properties' }} </span>
                                                                        </span>
                                                                </template>
                                                                <template v-slot:body>
                                                                    <!-- Show Modified Properties First -->
                                                                    <template v-if="level !== 'property'">
                                                                        <span class="hb-font-body-medium"
                                                                            v-if="item?.modified_properties?.length">
                                                                            Property Modified ({{
                                                                                item?.modified_properties?.length }})
                                                                        </span>
                                                                        <div class="d-flex"
                                                                            v-if="item?.modified_properties?.length">
                                                                            <div class="mr-1">
                                                                                <HbIcon
                                                                                    :mdi-code="TEMPLATE.ICONS.property_modified.icon"
                                                                                    small
                                                                                    :color="TEMPLATE.ICONS.property_modified.icon_color" />
                                                                            </div>
                                                                            <div v-html="TEMPLATE.ICONS.property_modified.name"
                                                                                class="font-weight-medium"></div>
                                                                        </div>
                                                                        <template
                                                                            v-if="item?.modified_properties?.length">
                                                                            <div v-for="p in item?.modified_properties"
                                                                                :key="p.id">
                                                                                <span v-if="p">{{ p?.property_number }}
                                                                                    - {{
                                                                                        p?.property_name }}</span>
                                                                            </div>
                                                                        </template>
                                                                        <v-spacer class="mt-2"></v-spacer>
                                                                    </template>

                                                                    <!-- Show Applied Properties Only If They Are Not in Modified Properties -->

                                                                    <template v-if="item?.applied_properties?.length">
                                                                        <span class="hb-font-body-medium">
                                                                            Applies to {{
                                                                                item?.applied_properties.length }}
                                                                            {{ item?.applied_properties.length <= 1
                                                                                ? 'Property' : 'Properties' }} </span>
                                                                                <div class="d-flex">
                                                                                    <div class="mr-1">
                                                                                        <HbIcon
                                                                                            :mdi-code="TEMPLATE.ICONS[item.templateStatus].icon"
                                                                                            small
                                                                                            :color="TEMPLATE.ICONS[item.templateStatus].icon_color" />
                                                                                    </div>
                                                                                    <div v-html="TEMPLATE.ICONS[item.templateStatus].name"
                                                                                        class="font-weight-medium">
                                                                                    </div>
                                                                                </div>
                                                                                <div v-for="p in item?.applied_properties"
                                                                                    :key="p.id">
                                                                                    <span v-if="p">{{ p?.property_number
                                                                                        }} - {{ p?.property_name
                                                                                        }}</span>
                                                                                </div>
                                                                    </template>
                                                                </template>

                                                            </hb-tooltip>
                                                        </div>
                                                    </div>
                                                    <div class="mx-2 d-flex align-center pr-1 child-status ">
                                                        <div class="mr-1">
                                                            <HbIcon :mdi-code="TEMPLATE.ICONS[item.templateStatus].icon"
                                                                small
                                                                :color="TEMPLATE.ICONS[item.templateStatus].icon_color" />
                                                        </div>
                                                        <div v-html="TEMPLATE.ICONS[item.templateStatus].name"
                                                            class="font-weight-medium"></div>
                                                    </div>
                                                    <div class="child">
                                                        <hb-tooltip>
                                                            <template v-slot:item>
                                                                <HbIcon mdi-code="mdi-account-clock-outline"
                                                                    class="mx-2" small />
                                                            </template>
                                                            <template v-slot:header>
                                                                Last Modified
                                                            </template>
                                                            <template v-slot:body>
                                                                <div v-if="item.modified_by?.name">
                                                                    {{
                                                                        item.modified_by.name
                                                                    }}</div>
                                                                <div v-if="item.updated_at">
                                                                    {{
                                                                        formatUpdatedAt(item.updated_at)
                                                                    }}</div>
                                                            </template>
                                                        </hb-tooltip>
                                                    </div>
                                                    <div class="child"><hb-menu options options-hover-color="#E0F5F5">
                                                            <v-list>
                                                                <v-list-item
                                                                    @click="editTemplate(item, 'user-generated')">
                                                                    <v-list-item-title>Edit</v-list-item-title>
                                                                </v-list-item>
                                                                <v-list-item
                                                                    @click="duplicateTemplate(item, 'user-generated')"
                                                                    :disabled="item.is_base_template"
                                                                    v-if="level !== 'property'">
                                                                    <v-list-item-title>Duplicate</v-list-item-title>
                                                                </v-list-item>
                                                                <v-list-item @click="resetToDefOrCorp(item, level)"
                                                                    v-if="level == 'property'"
                                                                    :disabled="!(item.templateStatus == 'property_modified' && level == 'property')">
                                                                    <v-list-item-title>Reset
                                                                        to Corporate</v-list-item-title>
                                                                </v-list-item>
                                                                <!-- <v-list-item @click="deleteTemplate(item)"
                                                                    v-if="level !== 'property'" disable>
                                                                    <v-list-item-title>Delete</v-list-item-title>
                                                                </v-list-item> -->
                                                            </v-list>
                                                        </hb-menu>
                                                    </div>
                                                </div>
                                            </template>
                                        </hb-btn>
                                    </div>
                                </div>
                                <div v-else-if="userGeneratedTemplates.length == 0 && !mainLoading" class="pa-4">
                                    <hb-empty-state <hb-empty-state
                                        :message="isFilterApplied ? 'No templates found' : 'You have no templates yet.'"
                                        btn-txt="Create
                            New Template" @click="createNewTemplate()"
                                        :show-btn="level !== 'property' && !isFilterApplied" />
                                </div>
                            </template>
                        </hb-expansion-panel>
                    </v-expansion-panels>
                </template>
            </div>
        </div>

        <!-- delete popup -->
        <hb-modal size="medium" title="Delete Template" v-model="deletePopup" confirmation>
            <template v-slot:content>
                <div class="py-4 px-6">
                    Are you sure you want to delete the selected template?
                </div>
            </template>
            <template v-slot:left-actions>
            </template>
            <template v-slot:right-actions>
                <hb-btn color="destructive" @click="finalDelete()">Delete</hb-btn>
            </template>
        </hb-modal>

        <hb-modal size="medium" title="Reset Template" v-model="resetToWhat" confirmation>
            <template v-slot:content>
                <div class="py-4 px-6">
                    {{ resetMessage }}
                </div>
            </template>
            <template v-slot:left-actions>
            </template>
            <template v-slot:right-actions>
                <hb-btn color="destructive" @click="finalReset()" :loading="resetLoading">Reset</hb-btn>
            </template>
        </hb-modal>

        <hb-modal size="medium" title="Delete Template" v-model="deletePopup" confirmation>
            <template v-slot:content>
                <div class="py-4 px-6">
                    Are you sure you want to delete the selected template?
                </div>
            </template>
            <template v-slot:left-actions>
            </template>
            <template v-slot:right-actions>
                <hb-btn color="destructive" @click="finalDelete()">Delete</hb-btn>
            </template>
        </hb-modal>

        <!-- <hb-modal size="medium" title="Unassign Template" v-model="unassignPopup" confirmation>
            <template v-slot:content>
                <div v-if="isAssigned" class="py-4 px-6">
                    This template is currently assigned to actions in active processes
                    Do you want to select a replacement template?
                    <div class="mt-5 mb-5">
                        <HbSelect v-model="replacement_template" :items="listOfTemplates" full
                            v-validate="'required|max:45'" data-vv-scope="default" data-vv-name="replacement_template"
                            data-vv-as="replacement_template" :error="errors.has('default.replacement_template')"
                            placeholder="Select Replacement Template">
                        </HbSelect>
                    </div>
                    if no replacement template is selected , any action that had this template applied will be changes
                    to a
                    blank message
                </div>
                <div v-else class="py-4 px-6">
                    Are you sure you want to unassign the selected template?
                </div>
            </template>
            <template v-slot:left-actions>
            </template>
            <template v-slot:right-actions>
                <hb-btn color="destructive" @click="finalUnassign()" disabled>Unassign </hb-btn>
            </template>
        </hb-modal> -->

        <!-- multi assign popup -->
        <hb-modal size="large" title="Assign Templates" v-model="multiAssignPopUp">
            <template v-slot:content>
                <v-container>
                    <!-- header section -->
                    <div class="d-flex justify-space-between align-center pa-2">
                        <!-- <HbTextField search width="90%" v-model="searchTemplateAssign" v-validate="'required|max:45'"
                            data-vv-scope="default" data-vv-name="search-templates" data-vv-as="search-templates"
                            :error="errors.has('default.search-templates')" @click:clear="clearSearch"
                            @input="onSearchInput" placeholder="Search Templates" /> -->
                        <HbBtn type="icon" active-state-off tooltip="Filter" @click="ShowFilter = true" class="mr-3">
                            <template>
                                <v-badge color="#F26500" dot :value=isFilterApplied>
                                    <hb-icon>mdi-filter-variant</hb-icon>
                                </v-badge>
                            </template>
                        </HbBtn>
                    </div>

                    <!-- content section  -->
                    <div style="margin: 7px;" v-for="item in UnassignedTemplates" :key="item.id">
                        <hb-btn mega>
                            <div class="mt-4">
                                <v-checkbox :value="item.id" v-model="checkedItems" />
                            </div>
                            <template v-slot:actions>
                                <div>
                                    {{ item.name }}
                                </div>
                            </template>
                        </hb-btn>
                    </div>
                </v-container>

            </template>
            <template v-slot:right-actions>
                <hb-btn @click="assignTemplates">Assign</hb-btn>
            </template>
        </hb-modal>

        <!--  filter popup -->
        <hb-modal size="large" title="Filter By" v-model="ShowFilter">
            <template v-slot:content>
                <hb-form label="Category" full>
                    <v-row>
                        <v-col cols="12">
                            <v-checkbox v-for="(item, index) in items" class="ma-0 pa-0" :key="index" :label="item.text"
                                v-model="selectedCategory" :value="item.value" />
                        </v-col>
                    </v-row>
                </hb-form>
                <hb-form label="Template Type" full>
                    <v-row>
                        <v-col cols="12">
                            <v-checkbox v-for="(item, index) in templateTypes" class="ma-0 pa-0" :key="index"
                                :label="item.label" v-model="selectedType" :value="item.value" />
                        </v-col>
                    </v-row>
                </hb-form>
                <hb-form label="Status" full :divider="false">
                    <v-row>
                        <v-col cols="12">
                            <v-checkbox v-for="status in statusOptions" :key="status.value" class="ma-0 pa-0"
                                :label="status.label" :value="status.value" v-model="selectedStatuses" />
                        </v-col>
                    </v-row>
                </hb-form>
            </template>
            <template v-slot:right-actions>
                <hb-btn @click="applyFilter()" :loading="loadingFilter">Apply</hb-btn>
            </template>
        </hb-modal>

        <div v-if="containerLoading" class="loading-overlay">
            <v-progress-circular indeterminate color="primary" size="50" />
        </div>
        <hb-modal v-model="permissionModal" size="medium" title="Required Permission" confirmation :footer-off="true">
            <template v-slot:content>
                <div class="px-6 py-4">
                    <div class="pb-2">
                        You do not have the required permission to perform this action.
                    </div>
                    <div>
                        Required Permission:
                        <span class="hb-font-body-medium">
                            {{ permission }}
                        </span>
                    </div>
                </div>
            </template>
        </hb-modal>

        <!--  filter popup -->
        <hb-modal size="large" title="Filter By" v-model="ShowFilter">
            <template v-slot:content>
                <hb-form label="Category" full>
                    <v-row>
                        <v-col cols="12">
                            <v-checkbox v-for="(item, index) in items" class="ma-0 pa-0" :key="index" :label="item.text"
                                v-model="selectedCategory" :value="item.value" />
                        </v-col>
                    </v-row>
                </hb-form>
                <hb-form label="Template Type" full>
                    <v-row>
                        <v-col cols="12">
                            <v-checkbox v-for="(item, index) in templateTypes" class="ma-0 pa-0" :key="index"
                                :label="item.label" v-model="selectedType" :value="item.value" />
                        </v-col>
                    </v-row>
                </hb-form>
                <hb-form label="Status" full :divider="false">
                    <v-row>
                        <v-col cols="12">
                            <v-checkbox v-for="status in statusOptions" :key="status.value" class="ma-0 pa-0"
                                :label="status.label" :value="status.value" v-model="selectedStatuses" />
                        </v-col>
                    </v-row>
                </hb-form>
            </template>
            <template v-slot:right-actions>
                <hb-btn @click="applyFilter()" :loading="loadingFilter">Apply</hb-btn>
            </template>
        </hb-modal>

        <div v-if="containerLoading" class="loading-overlay">
            <v-progress-circular indeterminate color="primary" size="50" />
        </div>

    </div>
</template>

<script type="text/babel">
import api from '../../../assets/api.js';
import { mapGetters } from "vuex";
import settingsTabMixin from '../../../mixins/settingsTabMixin.js';
import { notificationMixin } from '../../../mixins/notificationMixin.js';
import { EventBus } from '../../../EventBus';
import MenuTabs from '../Common/MenuTabs';
import TEMPLATE from '@/constants/template.js';
import moment from 'moment';

export default {
    name: "CommunicationTemplates",
    mixins: [settingsTabMixin, notificationMixin],
    data() {
        return {
            hasFetchedTemplateData: false,
            containerLoading: false,
            isExpansionPanelWidthBelow800: false,
            mainLoading: false,
            TEMPLATE: '',
            level: 'corporate',
            searchTemplate: '',
            replacement_template: '',
            property: {},
            panel: 0,
            templatesPanel: [],
            defaultTemplateList: [],
            userGeneratedTemplates: [],
            mainTemplates: [],

            deletePopup: false,// for delete popup

            // unassignPopup: false, // for unassign popup
            multiAssignPopUp: false,
            resetToWhat: false,
            resetMessage: '',
            resetLoading: false,
            selectedResetItemId: '',


            checkedItems: [],// Store the checked items here

            ShowFilter: false,
            selectedCategory: [],
            selectedType: [],
            loadingFilter: false,
            isFilterApplied: '',

            appliedCategory: [],
            appliedType: [],
            appliedStatuses: [],

            isAssigned: false, // if template is currently used or not
            currentItem: null,
            selectedTemplate: [], // assign template checkbox v-model
            loading: false,
            UnassignedTemplates: [],
            deleteId: '',
            singleSelect: false,
            // TODO : its should be in backend
            templateTypes: [
                { label: 'Email', value: 'email' },
                { label: 'SMS', value: 'sms' },

            ],
            selectedStatuses: [],
            statusOptions: [
                { label: "Tenant Template", value: "tenant_template" },
                { label: "User Generated", value: "user_generated_default" },
                { label: "Corporate Modified", value: "corporate_modified" },
                { label: "Property Modified", value: "property_modified" },
            ],
            items: [
                { text: 'Rent Change', value: 'rent_change' },
                { text: 'Delinquency', value: 'deliquency' },
                { text: 'Maintenance', value: 'maintenance' },
                { text: 'Alerts', value: 'alerts' },
                { text: 'General', value: 'general' },
                { text: 'Reservation', value: 'reservation' },
                { text: 'Rental', value: 'rental' },
                { text: 'Payment', value: 'payment' },
                { text: 'Lead', value: 'lead' }
            ],
            permission: '',
            permissionModal: false
        };
    },
    components: {
        MenuTabs
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            if (value.toUpperCase() === 'SMS') {
                return 'SMS'; // If the word is 'SMS', return it in all caps
            } else {
                return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase(); // Capitalize only the first letter
            }
        }
    },
    created() {
        this.TEMPLATE = TEMPLATE;
        EventBus.$on('CommunicationTemplate:refreshList', this.getBaseTemplateData);
    },
    destroyed() {
        EventBus.$off('CommunicationTemplate:refreshList', this.getBaseTemplateData);
    },
    computed: {
        ...mapGetters({
            facilityList: "propertiesStore/filtered",
            properties: "propertiesStore/properties",
            hasPermission: "authenticationStore/rolePermission"
        }),
        isPropertySelected() {
            return !!this.property?.id;
        },
        isPropertyLevel() {
            return this.level === 'property' ? true : false;
        },
        listOfTemplates() {
            return this.defaultTemplateList.map(obj => obj.name);
        },
    },
    watch: {
        ShowFilter(newVal) {
            if (newVal) {
                // When modal opens, sync from applied -> temporary
                this.selectedCategory = [...this.appliedCategory];
                this.selectedType = [...this.appliedType];
                this.selectedStatuses = [...this.appliedStatuses];
            }
        },
        property: {
            async handler(value) {
                // Emit the value to the parent component
                await this.getBaseTemplateData()
            },
            deep: true
        },
        templatesPanel(newValue) {
            // Ensure only one panel is open
            if (newValue.length > 1) {
                this.templatesPanel = [newValue[newValue.length - 1]]; // Keep only the last opened panel
            }
            if (!this.hasFetchedTemplateData && this.level !== 'property') {
                this.loadBaseTemplateData();
            }
        },
    },
    methods: {
        async loadBaseTemplateData() {
            this.hasFetchedTemplateData = true;
            await this.getBaseTemplateData();
        },
        resizeContainer() {
            const width = this.$refs.expansionPanels.$el?.offsetWidth
            if (width < 900) {
                this.isExpansionPanelWidthBelow800 = true
            }
            else
                this.isExpansionPanelWidthBelow800 = false
        },
        isAllPropertiesModified(item) {
            if (!item?.applied_properties?.length || !item?.modified_properties?.length) {
                return false;
            }
            const modifiedIds = new Set(item.modified_properties.map(p => p.id));
            return item.applied_properties.every(p => modifiedIds.has(p.id));
        },
        onSearchInput: _.debounce(function () {
            this.getBaseTemplateData();
        }, 500),
        getCategory(cat) {
            const item = this.items.find(item => item.value === cat);
            return item ? item.text : null;
        },
        getPropertyCount(ids) {
            let count = 0;
            ids.forEach(id => {
                if (this.facilityList.find(property => property.id === id)) {
                    count++;
                }
            });
            return count;
        },
        getPropertyById(id) {
            return this.facilityList.find(property => property.id === id);
        },
        async clearSearch() {
            return this.defaultTemplateList;
        },
        async initializeData() {
            // created because of mixin
        },
        formatUpdatedAt(updatedAt) {
            if (updatedAt) {
                // Adjust the format as needed
                return moment.utc(updatedAt).local().format("MMM D, YYYY @ hh:mma");
            }
            return ""; // Or any default value for empty updated_at
        },
        async selectedProperty(property) {
            if (this.property != property) {
                this.property = property;
            }
        },
        setMenuOption(option) {
            this.level = option
            this.property = ''
            this.searchTemplate = ''
        },
        async getBaseTemplateData() {
            try {
                this.mainLoading = true;
                this.loadingFilter = true
                // Construct the payload for search and filter
                const data = {
                    searchQuery: this.searchTemplate || '', // Use searchTemplate for search
                    filterKeys: {
                        category: this.selectedCategory.length ? this.selectedCategory : null,
                        type: this.selectedType.length ? this.selectedType : null,
                        TemplateStatus: this.selectedStatuses.length ? this.selectedStatuses : null
                    },
                };

                let url = api.TEMPLATE_MANAGER + `templates`;

                // url += `?get_only_active_templates=true`;
                // Append property_id if applicable
                let isFirstParam = true; // Tracks if this is the first query parameter
                if (this.isPropertySelected) {
                    url += `?property_id=${this.property.id}`;
                    isFirstParam = false; // First parameter added, set to false
                }

                if (data.filterKeys.category) {
                    url += `${isFirstParam ? '?' : '&'}filterKeys[category]=${data.filterKeys.category.join(',')}`;
                    isFirstParam = false; // Now subsequent parameters will use &
                }

                if (data.filterKeys.type) {
                    url += `${isFirstParam ? '?' : '&'}filterKeys[type]=${data.filterKeys.type.join(',')}`;
                    isFirstParam = false;
                }

                if (data.filterKeys.TemplateStatus) {
                    url += `${isFirstParam ? '?' : '&'}filterKeys[TemplateStatus]=${data.filterKeys.TemplateStatus.join(',')}`;
                    isFirstParam = false;
                }

                if (data.searchQuery) {
                    url += `${isFirstParam ? '?' : '&'}searchQuery=${encodeURIComponent(data.searchQuery)}`;
                }
                this.loading = true;
                // Make API call
                const resp = await api.get(this, url);
                // Assign the results
                this.mainTemplates = resp.templates;
                // Separate default templates
                this.defaultTemplateList = this.mainTemplates.filter(
                    template => template.status === 'active' && template.is_base_template === 1
                );
                // Separate user-generated templates
                this.userGeneratedTemplates = this.mainTemplates.filter(
                    template => template.status === 'active' && template.is_base_template !== 1
                );
                this.loadingFilter = false
                this.ShowFilter = false
            } catch (error) {
                this.loadingFilter = false
                console.error('Error fetching templates:', error);
                this.ShowFilter = false
                // Handle error case
            } finally {
                // End loading
                this.loadingFilter = false
                this.ShowFilter = false
                this.loading = false;
                this.mainLoading = false;
            }
        },

        resetToDefOrCorp(item, level) {

            const isCorporateTab = level === "corporate";
            const isPropertyTab = level === "property";

            if ((isCorporateTab && this.hasPermission("edit_reset_templates_in_corporate")) ||
                (isPropertyTab && this.hasPermission("edit_reset_templates_in_property"))) {

                this.resetToWhat = true; // Open modal
                this.selectedResetItemId = item.id; // Store item ID for reset action (template_id)
                this.resetMessage = isPropertyTab
                    ? "Are you sure you want to reset this to the corporate template?"
                    : "Are you sure you want to reset this to a Tenant template?";

            } else {
                this.permission = isCorporateTab
                    ? "Manage (Edit/Reset to Default) templates in Corporate Settings"
                    : "Manage (Edit/Reset to Default) templates in Property Settings";
                this.permissionModal = true;
            }
        },


        async finalReset() {
            if (!this.selectedResetItemId) return; // Ensure there's an item to reset

            try {
                this.resetLoading = true
                const endpoint = this.currentItem?.propertyId
                    ? `${api.TEMPLATE_MANAGER}template/status?property_id=${this.currentItem?.propertyId}`
                    : `${api.TEMPLATE_MANAGER}template/status`;

                const payload = {
                    template_id: this.selectedResetItemId
                    // Add necessary data for the API call
                };

                await api.put(this, endpoint, payload);
                this.resetLoading = false
                this.showMessageNotification({
                    type: 'success',
                    description: "Template reset successfully",
                });

                await EventBus.$emit('CommunicationTemplate:refreshList'); // Refresh the list

            } catch (error) {
                console.error("Error resetting template:", error);
                this.resetLoading = false
                this.showMessageNotification({
                    type: 'error',
                    description: "Failed to reset the template. Please try again.",
                });
            } finally {
                this.resetLoading = false
                this.resetToWhat = false; // Close modal after reset
                this.selectedResetItemId = null; // Clear stored ID
            }
        },


        deleteTemplate(item) {
            this.deletePopup = true
        },

        async finalDelete() {
            try {
                let resp;
                if (this.isPropertySelected) {
                    resp = await api.delete(this, api.TEMPLATE_MANAGER + `template/${this.deleteId}` + `?property_id=${this.property.id}`);
                }
                else {
                    resp = await api.delete(this, api.TEMPLATE_MANAGER + `template/${this.deleteId}`);
                }
                EventBus.$emit('CommunicationTemplate:refreshList')
                this.showMessageNotification({ type: 'success', description: "Template Deleted successfully" });
            } catch (error) {
                console.error(error);
                this.showMessageNotification({ type: 'error', description: "Something went wrong" });
            }
        },

        // unassignTemplate(item) {
        //     this.unassignPopup = true
        //     this.deleteId = item.template_id
        // },
        // async finalUnassign() {
        //     try {
        //         let resp;
        //         if (this.isPropertySelected) {
        //             resp = await api.delete(this, api.TEMPLATE_MANAGER + `template/${this.deleteId}` + `?property_id=${this.property.id}`);
        //         }
        //         else {
        //             resp = await api.delete(this, api.TEMPLATE_MANAGER + `template/${this.deleteId}`);
        //         }
        //         this.unassignPopup = false
        //         EventBus.$emit('CommunicationTemplate:refreshList')
        //         this.showMessageNotification({ type: 'success', description: "Template unassigned successfully" });
        //     } catch (error) {
        //         console.error(error);
        //         this.showMessageNotification({ type: 'error', description: "Something went wrong" });
        //     }
        // },

        createNewTemplate() {
            if (this.hasPermission("create_duplicate_ugt_template")) {
                this.currentItem = {
                    isNew: true
                };
                EventBus.$emit('HB-Navigation:CommunicationTemplate', this.currentItem);
            } else {
                this.permission = 'Create/Duplicate User Defined Communication Templates'
                this.permissionModal = true
            }
        },

        async duplicateTemplate(item) {
            if (this.hasPermission("create_duplicate_ugt_template")) {
                try {
                    const key = item.template_id ? 'template_id' : 'base_template_id';
                    this.containerLoading = true;

                    const res = await api.get(this, api.TEMPLATE_MANAGER + `template?${key}=${item.id}`);

                    this.currentItem = {
                        item: item,
                        propertyId: this.property?.id, // if it is from property tab
                        data: res[0],
                        duplicate: true
                    };

                    EventBus.$emit('HB-Navigation:CommunicationTemplate', this.currentItem);
                } catch (error) {
                    console.error("Error duplicating template:", error);
                } finally {
                    this.containerLoading = false;
                }
            } else {
                this.permission = 'Create/Duplicate User Defined Communication Templates'
                this.permissionModal = true
            }
        },


        async editTemplate(item) {
            const isCorporateTab = this.level === "corporate";
            const isPropertyTab = this.level === "property";

            if ((isCorporateTab && this.hasPermission("edit_reset_templates_in_corporate")) ||
                (isPropertyTab && this.hasPermission("edit_reset_templates_in_property"))) {
                try {
                    const key = item.template_id ? 'template_id' : 'base_template_id';
                    this.containerLoading = true;

                    const res = await api.get(this, api.TEMPLATE_MANAGER + `template?${key}=${item.id}`);

                    this.currentItem = {
                        item: item,
                        propertyId: this.property.id, // only relevant if in property tab
                        data: res[0],
                        edit: true
                    };

                    EventBus.$emit('HB-Navigation:CommunicationTemplate', this.currentItem);
                } catch (error) {
                    console.error("Error fetching template:", error);
                } finally {
                    this.containerLoading = false;
                }
            } else {
                this.permission = isCorporateTab
                    ? 'Manage (Edit/Reset to Default) templates in Corporate Settings'
                    : 'Manage (Edit/Reset to Default) templates in Property Settings';
                this.permissionModal = true;
            }
        },


        async applyFilter() {
            this.appliedCategory = [...this.selectedCategory];
            this.appliedType = [...this.selectedType];
            this.appliedStatuses = [...this.selectedStatuses];

            // Run the actual filter logic
            await this.getBaseTemplateData();

            this.isFilterApplied =
                this.selectedCategory.length +
                this.selectedType.length +
                this.selectedStatuses.length;
        },


        // multi assign part
        async fetchUnassignedTemplates() {
            const resp = await api.get(this, api.TEMPLATE_MANAGER + `templates`);
            this.UnassignedTemplates = resp.templates;
        },
        assignTemplate() {
            this.checkedItems = [];
            this.multiAssignPopUp = true // open modal
            this.fetchUnassignedTemplates() // fetch data
        },
        async assignTemplates() {
            const data = this.UnassignedTemplates.filter(item =>
                this.checkedItems.includes(item.id)
            );
            console.log(data, "data");
            // assign api
        },
    }
}
</script>
<style scoped>
.expansion-panel-item>>>.hb-mega-button>.v-btn__content {
    flex: 1;
}

.expansion-panel-item>>>.hb-mega-button>.v-btn__content:first-of-type>span:first-of-type {
    overflow-x: hidden;
    text-overflow: ellipsis;
    width: 350px;
    text-align: left;
}

.expansion-panel-item-small-width>>>.hb-mega-button>.v-btn__content:first-of-type>span:first-of-type {
    width: 180px;
}

.container-main {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
}

.child {
    flex: 0 0 0;
    justify-content: start;
    width: 40px;
    display: flex;
    margin-left: 8px;

}

.child-category {
    flex: 2 0 0;
    text-align: start;
    width: 150px;
}

.child-type {
    flex: 2 0 0;
    text-align: start;
    width: 150px;
    margin-left: 45px;
}

.child-property {
    flex: 2 0 0;
    text-align: start;
    width: 150px;
}

.child-status {
    width: 150px;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(34, 34, 34, 0.5);
    /* Dark overlay */
    z-index: 9999;
}
</style>